import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  barcode: null
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  setbarcode(state, payload) {
    state.barcode = payload
  }
}

export default new Vuex.Store({
  state,
  mutations
})

/*
export default new Vuex.Store({
  state: {
    barcode: null
  },
  mutations: {
    setbarcode(state, payload) {
      state.barcode = payload
    }
  }
})*/